import { useFilterStore } from "@faire/deprecated-retailer-visitor-shared/components/Filters/useFilterStore";
import { SDUIOnViewActionsHandler } from "@faire/deprecated-retailer-visitor-shared/components/SDUI/__internal__/ActionHandler/SDUIOnViewActionHandler";
import { LoggingEventParams } from "@faire/deprecated-retailer-visitor-shared/components/SDUI/__internal__/types";
import { useMaybeAssignCategoryTreeExperiment } from "@faire/deprecated-retailer-visitor-shared/lib/useMaybeAssignCategoryTreeExperiment";
import { useRecordMilestoneByDay } from "@faire/deprecated-retailer-visitor-shared/stores/domain/useMilestone";
import { IAction } from "@faire/web-api--source/indigofair/data/IAction";
import { useCallback } from "react";
import { useHistory } from "react-router-dom";

export function useSDUIActionsHandler(
  actions: IAction[],
  loggingData: LoggingEventParams
): () => void {
  const history = useHistory();
  const recordMilestoneOnceByDay = useRecordMilestoneByDay();
  const { clearAllFilters } = useFilterStore([]);
  const maybeAssignCategoryTreeExperiment =
    useMaybeAssignCategoryTreeExperiment();

  return useCallback(() => {
    SDUIOnViewActionsHandler(
      actions,
      loggingData,
      history,
      recordMilestoneOnceByDay,
      clearAllFilters,
      maybeAssignCategoryTreeExperiment
    );
  }, [
    actions,
    loggingData,
    history,
    recordMilestoneOnceByDay,
    clearAllFilters,
    maybeAssignCategoryTreeExperiment,
  ]);
}
